import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SectionGiftUseCasesComponent } from './section-gift-use-cases.component';
import { UseCaseItemComponent } from './components/use-case-item/use-case-item.component';

@NgModule({
  declarations: [SectionGiftUseCasesComponent, UseCaseItemComponent],
  imports: [CommonModule],
  exports: [SectionGiftUseCasesComponent],
})
export class SectionGiftUseCasesModule {}
